<ng-container *transloco="let t">
    <app-admin-card-with-title
            [cardTitle]="t('league.scoring.definition.title')" [showToggleButton]="true"
            [isContentVisible]="!isScoringDefinitionCollapsed" [removeTopMargin]="true">
        <div slot="trailingWidget">
            @if (!disableEditing) {
                <div class="pe-4">
                    <app-rounded-button [label]="t('league.scoring.definition.add')"
                                        (onClick)="openScoringDefinitionModal()" [isDisabled]="disableEditing"
                                        [btnClass]="'rounded-button--solid'">
                        <i class="bi bi-plus-circle pe-2"></i>
                    </app-rounded-button>
                </div>
            }
        </div>
        @if (scoringDefinitions.length > 0) {
        <div class="table-responsive">
          <table class="table dark-header table-last-row-no-border">
            <thead>
            <tr>
                      <th>{{ t('app.common.item.name') }}</th>
                      <th>{{ t('league.scoring.method.short') }}</th>
                      <th>{{ t('league.scoring.max.base.points') }}</th>
                      <th>{{ t('league.scoring.ranking.method') }}</th>
              <th class="more-column-width"></th>
  </tr>
  </thead>
  <tr app-table-header-separator></tr>
  <tbody>
    @for (scoringDefinition of scoringDefinitions; track scoringDefinition; let idx = $index) {
            <tr>
                <td class="center-align">{{ scoringDefinition.name }}</td>
                <td class="center-align">{{ t("league.scoring.method." + scoringDefinition.scoringMethod) }}</td>
                <td class="center-align">{{ scoringDefinition.maxBasePoints ?? "-" }}</td>
                <td class="center-align">{{ t("league.scoring.ranking.method." + scoringDefinition.rankingMethod) }}</td>
                <td class="text-end center-align">
                <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                        <span class="menu-icon" id="scoringDefinitionsActionsDropdown" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v"></i>
                        </span>
                    <ul aria-labelledby="scoringDefinitionsActionsDropdown" ngbDropdownMenu>
                        <li ngbDropdownItem (click)="openScoringDefinitionModal(scoringDefinition, idx)">
                            {{ t(disableEditing ? "app.common.view":  "app.common.edit") }}
                        </li>
                        @if (!disableEditing) {
                            <li ngbDropdownItem (click)="openDeleteScoringDefinitionModal(scoringDefinition, idx)">
                            {{ t("app.common.delete") }}
                            </li>
                        }

                    </ul>
                </div>
            </td>
        </tr>
        }
        </table>
      </div>
        } @else {
        <div class="my-3">
          <app-empty-state-admin/>
        </div>
        }
    </app-admin-card-with-title>

    <!--  INDIVIDUAL SCORING CONFIG -->
    <div class="mt-4">
        <app-admin-card-with-title
            [cardTitle]="t('league.scoring.individual.config.title')"
            [showToggleButton]="true"
            [isContentVisible]="!isIndividualConfigCollapsed"
            [removeTopMargin]="true"
    >
        <div slot="trailingWidget">
            @if (!disableEditing) {
            <div class="pe-4">
                <app-rounded-button
                        [label]="t('league.scoring.individual.config.add')"
                        (onClick)="openIndividualConfigModal()"
                        [isDisabled]="!(scoringDefinitions.length > 0)"
                        [btnClass]="'rounded-button--solid'"
                >
                    <i class="bi bi-plus-circle pe-2"></i>
                </app-rounded-button>
            </div>
            }
        </div>

        @if (individualScoringConfigs.length > 0) {
        <div class="table-responsive">
          <table
            class="table dark-header table-last-row-no-border"
          >
            <thead>
              <tr>
            <th>{{ t('app.common.item.name') }}</th>
            <th>{{ t('league.scoring.definition') }}</th>
            <th>{{ t('league.scoring.minFinishedRacesForScoring.short') }}</th>
            <th>{{ t('league.scoring.maxFinishedRacesForScoring.short') }}</th>
            <th>{{ t('league.scoring.attendanceBonusType.short') }}</th>
            <th>{{ t('league.scoring.fixedAttendanceBonus.short') }}</th>
            <th class="more-column-width"></th>
          </tr>
        </thead>

        <tr app-table-header-separator></tr>

        <tbody>
          @for (cfg of individualScoringConfigs; track cfg;let idx = $index) {
        <tr>
            <td class="center-align">{{ cfg.name }}</td>
            <td class="center-align">{{ cfg.scoringDefinition?.name }}</td>
            <td class="center-align">{{ cfg.minFinishedRacesForScoring ?? "-" }}</td>
            <td class="center-align">{{ cfg.maxFinishedRacesForScoring ?? "-" }}</td>
            <td class="center-align">
                {{ t("league.scoring.attendanceBonusType." + cfg.attendanceBonusType) }}
            </td>
            <td class="center-align">{{ cfg.fixedAttendanceBonus ?? "-" }}</td>

            <td class="text-end center-align">
                <div
                        ngbDropdown
                        class="dropdown dropdown--remove-arrow"
                        container="body"
                >
                  <span
                          class="menu-icon"
                          id="individualConfigActionsDropdown"
                          ngbDropdownToggle
                  >
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                    <ul
                            aria-labelledby="individualConfigActionsDropdown"
                            ngbDropdownMenu
                    >
                        <li ngbDropdownItem (click)="openIndividualConfigModal(cfg, idx)">
                            {{ t(disableEditing ? "app.common.view":  "app.common.edit") }}
                        </li>
                        @if (!disableEditing) {
                        <li ngbDropdownItem (click)="openDeleteConfigModal(cfg, false, idx)">
                            {{ t('app.common.delete') }}
                        </li>
                        }
                    </ul>
                </div>
            </td>
        </tr>
        }
        </tbody>
      </table>
    </div>
        } @else {
        <div class="my-3">
          <app-empty-state-admin [message]="!(scoringDefinitions.length > 0) ? 'league.scoring.definitions.add.individual.empty.message' : undefined" />
        </div>
        }
    </app-admin-card-with-title>
    </div>

    <!--    GROUP SCORING CONFIG   -->
    <div class="mt-4">
    <app-admin-card-with-title
            [cardTitle]="t('league.scoring.group.config.title')"
            [showToggleButton]="true"
            [isContentVisible]="!isGroupConfigCollapsed"
            [removeTopMargin]="true"
    >
        <div slot="trailingWidget">
            @if (!disableEditing) {
            <div class="pe-4">
                <app-rounded-button [isDisabled]="!(scoringDefinitions.length > 0)"
                        [label]="t('league.scoring.group.config.add')"
                        (onClick)="openGroupConfigModal()"
                        [btnClass]="'rounded-button--solid'"
                >
                    <i class="bi bi-plus-circle pe-2"></i>
                </app-rounded-button>
            </div>
            }
        </div>

        @if (groupScoringConfigs.length > 0) {
        <div class="table-responsive">
          <table
            class="table dark-header table-last-row-no-border"
            infinite-scroll
            [infiniteScrollDistance]="4"
          >
            <thead>
              <tr>
            <th>{{ t('app.common.item.name') }}</th>
            <th>{{ t('league.scoring.definition') }}</th>
            <th>{{ t('league.scoring.groupScoringType.short') }}</th>
            <th>{{ t('league.scoring.maxScoringRounds.short') }}</th>
            <th>{{ t('league.scoring.maxTeamMembers.short') }}</th>
            <th>{{ t('league.scoring.maxScoringMembers.short') }}</th>
            <th class="more-column-width"></th>
          </tr>
        </thead>

        <tr app-table-header-separator></tr>

        <tbody>
          @for (cfg of groupScoringConfigs; track cfg;let idx = $index) {
        <tr>
            <td class="center-align">{{ cfg.name }}</td>
            <td class="center-align">{{ cfg.scoringDefinition?.name }}</td>

            <td class="center-align">
                {{ t("league.scoring.groupScoringType." + cfg.groupScoringType) }}
            </td>

            <td class="center-align">{{ cfg.maxScoringRounds ?? "-" }}</td>
            <td class="center-align">{{ cfg.maxTeamMembers ?? "-" }}</td>
            <td class="center-align">{{ cfg.maxScoringMembers ?? "-" }}</td>

            <td class="text-end center-align">
                <div
                        ngbDropdown
                        class="dropdown dropdown--remove-arrow"
                        container="body"
                >
                  <span
                          class="menu-icon"
                          id="groupConfigActionsDropdown"
                          ngbDropdownToggle
                  >
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                    <ul
                            aria-labelledby="groupConfigActionsDropdown"
                            ngbDropdownMenu
                    >
                        <li ngbDropdownItem (click)="openGroupConfigModal(cfg, idx)">
                            {{ t(disableEditing ? "app.common.view":  "app.common.edit") }}
                        </li>
                        @if (!disableEditing) {
                        <li ngbDropdownItem (click)="openDeleteConfigModal(cfg, true, idx)">
                            {{ t('app.common.delete') }}
                        </li>
                        }
                    </ul>
                </div>
            </td>
        </tr>
        }
        </tbody>
      </table>
    </div>
        } @else {
        <div class="my-3">
          <app-empty-state-admin [message]="!(scoringDefinitions.length > 0) ? 'league.scoring.definitions.add.group.empty.message' : undefined" />
        </div>
        }
    </app-admin-card-with-title>
    </div>

</ng-container>
